export class HtmlUtils {

    static formatPattern: RegExp = new RegExp('(\\n)|(\\\\n)|(\\\\\\\\n)|↵', 'g');

    // Escape html to display
    static formatHtmlDisplay(html: string): string {
        return html.replace(HtmlUtils.formatPattern, '<br>');
    }
}